import store from "@/store/store";
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

class MarcacaoController {
  public static async getDetalheAcompanhamento(
    nrVinculo: string,
    dates: string[],
    showLoading = true,
  ) {
    const route = 'getDetalheAcompanhamento';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      DATES: dates,
    };

    const response = await HttpRequest.get(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const marcacoes: any[] = response.data.dataset.data;

    return marcacoes;
  }

  public static async removeMarcacao(
    nrVinculo: string,
    nrMarcacao: string,
    showLoading = true,
  ) {
    const route = 'removeMarcacao';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        NRMARCACAOPONTO: nrMarcacao,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const success: boolean = response.data.dataset.data.success;

    return success;
  }

  public static async removeParesMarcacao(
    nrVinculo: string,
    dates: string[],
    hrEntrada: string,
    hrSaida: string,
    showLoading = true,
    idEntrada = 'FC',
    idSaida = 'FC',
  ) {
    const route = 'removeParesMarcacao';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: dates,
        HRENTRADA: hrEntrada,
        HRSAIDA: hrSaida,
        DIA_INICIO: idEntrada,
        DIA_FIM: idSaida,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const marcacoesRemovidas: number[] = response.data.dataset.data;
    const success = Array.isArray(marcacoesRemovidas);

    return success;
  }

  public static async editParesMarcacao(
    row: any,
    showLoading = true,
  ) {
    const route = 'editParesMarcacao';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: row.nrVinculo,
        DATE: row.dates,
        HRENTRADA: row.hrEntrada,
        HRSAIDA: row.hrSaida,
        NOVAHRENTRADA: row.hrNovaEntrada,
        NOVAHRSAIDA: row.hrNovaSaida,
        IDENTRADA: row.idEntrada,
        IDSAIDA: row.idSaida,
        NOVOIDENTRADA: row.novoIdEntrada,
        NOVOIDSAIDA: row.novoIdSaida,
      },
    };

    const response = await HttpRequest.post(route, params, showLoading);
    ExpectedError.throwResponseError(response);

    const success: boolean = response.data.dataset.data.success;

    return success;
  }

  public static async getParesMarcacoesDia(
    nrVinculo: string,
    date: string,
    showLoading = true,
    requestCode: number = null,
  ): Promise<any | undefined> {
    const route = 'getParesMarcacoesDia';

    const user: User = store.getters.user;
    const nrOrg = user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      DIA: date,
    };

    const response = await HttpRequest.get(route, params, showLoading, requestCode);

    if (response.data.messages) {
      const message = response.data.messages[0].message;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return undefined;
    }

    const pares: any[] = response.data.dataset.data;

    return pares;
  }
}

export default MarcacaoController;
